export type PerfilUsuario =
  | 'admin'
  | 'nutricionista'
  | 'logistica'
  | 'fiscal'
  | 'responsavel_escola'
export type StatusValidacaoEntrega =
  | 'pendente_fornecedor'
  | 'pendente_escola'
  | 'pendente_nutricionista'
  | 'concluida'
export type ZonaTipo = 'urbana' | 'rural'
export type TipoUnidadeEscola = 'EMEF' | 'EMEI' | 'PROJETO'
export type NivelEnsinoR065 = 'infantil' | 'fund_menor' | 'fund_maior' | 'eja'
export type GrupoProduto = 'secos' | 'hortifruti' | 'proteinas' | 'ovos' | 'polpas' | 'paes'
export type ModalidadeEnsino =
  | 'creche'
  | 'pre'
  | 'fund1'
  | 'fund2'
  | 'medio'
  | 'eja'
  | 'integral'
export type TipoDia = 'letivo' | 'feriado'
export type StatusContrato = 'zerado' | 'ok' | 'atencao' | 'critico' | 'excedido'
export type StatusEstoque = 'critico' | 'atencao' | 'ok'

export interface Usuario {
  id: string
  nome: string
  email: string
  perfil: PerfilUsuario
  ativo: boolean
  criado_em: string
}

export interface Rota {
  id: string
  nome: string
  responsavel: string
  zona: ZonaTipo
  nutricionista_id: string | null
  nutricionista?: { nome: string } | null
}

export interface EscolaResponsavel {
  id: string
  escola_id: string
  usuario_id: string
  criado_em: string
  usuario?: { nome: string; email: string }
}

export interface MatriculaTurnos {
  m: number
  t: number
  n: number
  i: number
  total: number
}

export interface Escola {
  id: string
  nome: string
  endereco: string | null
  bairro: string | null
  zona: ZonaTipo
  rota_id: string | null
  codigo_semed: number | null
  tipo_unidade: TipoUnidadeEscola | null
  alunos_creche: number
  alunos_pre: number
  alunos_fund1: number
  alunos_fund2: number
  alunos_medio: number
  alunos_eja: number
  alunos_integral: number
  alunos_ceact: number
  total_alunos: number
  infantil_m: number
  infantil_t: number
  infantil_n: number
  infantil_i: number
  fund_menor_m: number
  fund_menor_t: number
  fund_menor_n: number
  fund_menor_i: number
  fund_maior_m: number
  fund_maior_t: number
  fund_maior_n: number
  fund_maior_i: number
  eja_m: number
  eja_t: number
  eja_n: number
  eja_i: number
  /** true quando o operador ajustou turnos no cadastro; sync R065 não sobrescreve. */
  turnos_manuais: boolean
  atualizado_em: string
}

export interface EscolaCeact {
  id: string
  escola_id: string
  infantil_m: number
  infantil_t: number
  infantil_n: number
  infantil_i: number
  fund_menor_m: number
  fund_menor_t: number
  fund_menor_n: number
  fund_menor_i: number
  fund_maior_m: number
  fund_maior_t: number
  fund_maior_n: number
  fund_maior_i: number
  eja_m: number
  eja_t: number
  eja_n: number
  eja_i: number
  total: number
  atualizado_em: string
}

export interface MatriculaEscola {
  id: string
  escola_id: string | null
  codigo_semed: number
  nome_pdf: string
  tipo_unidade: TipoUnidadeEscola
  infantil_m: number
  infantil_t: number
  infantil_n: number
  infantil_i: number
  infantil_total: number
  fund_menor_m: number
  fund_menor_t: number
  fund_menor_n: number
  fund_menor_i: number
  fund_menor_total: number
  fund_maior_m: number
  fund_maior_t: number
  fund_maior_n: number
  fund_maior_i: number
  fund_maior_total: number
  eja_m: number
  eja_t: number
  eja_n: number
  eja_i: number
  eja_total: number
  total_escola: number
}

export interface MatriculaImportacao {
  id: string
  mes_referencia: string
  ano_letivo: number
  arquivo_nome: string | null
  importado_em: string
}

export type StatusAlimentoMacro =
  | 'permitido'
  | 'aquisicao_proibida'
  | 'oferta_limitada_maior_3_proibida_menor_igual_3'

export interface Produto {
  id: string
  nome: string
  grupo: GrupoProduto
  unidade: string
  /** Gramas por unidade comercial (un, maço); para ml = ml × g/ml. */
  gramas_por_unidade?: number | null
  /** Quantidade de unidades na embalagem (ex.: 30 ovos por cartela). */
  unidades_por_embalagem?: number | null
  /** Peso em gramas de cada unidade individual (ex.: 50 g por ovo). */
  gramas_por_item?: number | null
  /** Volume ml por unidade comercial (produtos líquidos). */
  ml_por_unidade?: number | null
  /** Densidade: gramas por 1 ml. */
  gramas_por_ml?: number | null
}

export interface AlimentoMacronutriente {
  id: string
  nome: string
  categoria: string
  produto_id: string | null
  produto?: Pick<Produto, 'nome' | 'grupo' | 'unidade'> | null
  status: StatusAlimentoMacro
  energia_kcal: number
  energia_kj: number
  carboidratos_g: number
  proteinas_g: number
  lipideos_g: number
  vitamina_a_mcg: number
  vitamina_c_g: number
  calcio_mg: number
  ferro_mg: number
  atualizado_em: string
}

export type TurnoReferencia = 'manha' | 'tarde' | 'noite' | 'integral'

/** Escopo de cardápio/ficha: parcial (Manhã/Tarde/Noite) vs integral independente. */
export type EscopoJornada = 'parcial' | 'integral'

/** @deprecated use TurnoReferencia */
export type JornadaReferencia = 'parcial' | 'integral'

export interface ValorReferenciaRefeicao {
  id: string
  modalidade: ModalidadeEnsino
  turno: TurnoReferencia
  energia_kcal: number
  energia_kj: number
  carboidratos_g_min: number
  carboidratos_g_max: number
  proteinas_g_min: number
  proteinas_g_max: number
  lipideos_g_min: number
  lipideos_g_max: number
  vitamina_a_mcg: number
  vitamina_c_g: number
  calcio_mg: number
  ferro_mg: number
  atualizado_em: string
}

export const TURNOS_REFERENCIA: {
  value: TurnoReferencia
  label: string
  pacote: string
}[] = [
  { value: 'manha', label: 'Manhã', pacote: 'Lanche manhã + Almoço' },
  { value: 'tarde', label: 'Tarde', pacote: 'Lanche tarde + Jantar' },
  { value: 'noite', label: 'Noite', pacote: 'Jantar' },
  { value: 'integral', label: 'Integral', pacote: 'Lanche manhã + Almoço + Lanche tarde + Jantar' },
]

export interface FichaTecnica {
  id: string
  modalidade: ModalidadeEnsino
  refeicao: string
  descritivo: string
  atualizado_em: string
  escopo_jornada: EscopoJornada
}

export interface ModalidadeCardapioConfig {
  modalidade: ModalidadeEnsino
  cardapio_integral_independente: boolean
  atualizado_em: string
}

export interface FichaTecnicaItem {
  id: string
  ficha_id: string
  alimento_id: string
  quantidade_g: number
  ordem: number
  origem_prato_id: string | null
}

export interface Prato {
  id: string
  nome: string
  refeicao: string
  descritivo: string
  atualizado_em: string
}

export interface PratoItem {
  id: string
  prato_id: string
  alimento_id: string
  quantidade_g: number
  ordem: number
}

export interface FichaTecnicaPrato {
  id: string
  ficha_id: string
  prato_id: string
  ordem: number
}

export const STATUS_ALIMENTO_MACRO_LABELS: Record<StatusAlimentoMacro, string> = {
  permitido: 'Permitido',
  aquisicao_proibida: 'Aquisição proibida',
  oferta_limitada_maior_3_proibida_menor_igual_3:
    'Oferta limitada para > 3 anos e proibida para ≤ 3 anos de idade',
}

export const CATEGORIAS_ALIMENTO_SUGESTOES = [
  'GÊNEROS SECOS',
  'HORTIFRUTI',
  'PROTEINA',
  'PÃES',
  'POLPA DE FRUTA',
] as const

export type TipoPessoa = 'PF' | 'PJ'

export interface Fornecedor {
  id: string
  /** Coluna gerada: nome fantasia ou razão social */
  nome: string
  razao_social: string
  nome_fantasia: string | null
  tipo_pessoa: TipoPessoa
  cpf_cnpj: string | null
  cep: string | null
  logradouro: string | null
  numero: string | null
  complemento: string | null
  bairro: string | null
  cidade: string | null
  uf: string | null
  responsavel_nome: string | null
  telefone: string | null
  celular: string | null
  email: string | null
  ativo: boolean
  criado_em: string
  atualizado_em: string
}

export const TIPO_PESSOA_LABELS: Record<TipoPessoa, string> = {
  PF: 'Pessoa Física',
  PJ: 'Pessoa Jurídica',
}

export const UFS_BR = [
  'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG',
  'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO',
] as const

export interface Preco {
  id: string
  produto_id: string
  valor_unitario: number
  vigencia_inicio: string
  fornecedor: string | null
  fornecedor_id: string | null
  criado_em?: string | null
}

export interface Contrato {
  id: string
  fornecedor: string
  cnpj: string
  valor_total: number
  periodo_referencia: string
  fornecedor_id: string | null
}

export interface ItemContrato {
  id: string
  contrato_id: string
  alimento_id: string
  quantidade_contratada: number
  quantidade_pedida: number
  valor_unitario: number
  quantidade_entregue: number
}

export interface Cardapio {
  id: string
  modalidade: ModalidadeEnsino
  trimestre: number
  semana: number
  dia_semana: number
  refeicao: string
  descricao: string
  nutricionista_responsavel: string
  ano: number
  prato_id: string | null
  escopo_jornada: EscopoJornada
}

export type StatusPlanejamento = 'planejado' | 'parcial' | 'concluido' | 'cancelado'

export interface PlanejamentoRota {
  id: string
  rota_id: string
  data_entrega: string
  status: StatusPlanejamento
  periodo_inicio: string | null
  periodo_fim: string | null
  compra_id: string | null
  responsavel_entrega_id: string | null
  criado_por: string | null
  criado_em: string
  rota?: { nome: string }
  compra?: { codigo: string; mes_referencia: string | null }
  responsavel_entrega?: { nome: string; email: string } | null
}

export interface PlanejamentoEscola {
  id: string
  planejamento_id: string
  escola_id: string
  ordem: number
  escola?: { nome: string }
  itens?: PlanejamentoItem[]
  entrega?: { id: string } | null
}

export interface PlanejamentoItem {
  id: string
  planejamento_escola_id: string
  alimento_id: string
  quantidade: number
  valor_unitario: number | null
  alimento?: { nome: string; categoria?: string; produto_id?: string | null }
}

export interface Entrega {
  id: string
  data: string
  rota_id: string
  escola_id: string
  grupo: GrupoProduto | null
  multiplos_grupos: boolean
  recebido_por: string
  itens_texto: string | null
  observacoes: string | null
  registrado_por: string
  criado_em: string
  planejamento_escola_id: string | null
  fornecedor_nome: string | null
  validado_fornecedor_em: string | null
  validado_fornecedor_por: string | null
  validado_escola_em: string | null
  validado_escola_por: string | null
  justificativa_divergencia: string | null
  validado_nutricionista_em: string | null
  validado_nutricionista_por: string | null
  status_validacao: StatusValidacaoEntrega
}

export interface EntregaItem {
  id: string
  entrega_id: string
  alimento_id: string
  quantidade: number
  quantidade_planejada: number
  valor_unitario: number | null
  alimento?: { nome: string; categoria?: string; produto_id?: string | null }
}

export interface EntregaAnexo {
  id: string
  entrega_id: string
  path: string
  nome_arquivo: string
  uploaded_by: string
  criado_em: string
}

/** Ciclo de validação Nutricionista ISEN (perfil fiscal). */
export type StatusValidacaoPedido =
  | 'rascunho'
  | 'aguardando_isen'
  | 'validado_isen'
  | 'rejeitado'

export const STATUS_VALIDACAO_PEDIDO_LABELS: Record<StatusValidacaoPedido, string> = {
  rascunho: 'Rascunho',
  aguardando_isen: 'Aguardando ISEN',
  validado_isen: 'Validado ISEN',
  rejeitado: 'Rejeitado',
}

export interface Compra {
  id: string
  fornecedor_id: string
  contrato_id: string | null
  data_compra: string
  nota_fiscal: string | null
  mes_referencia: string | null
  periodo_inicio: string
  periodo_fim: string
  numero: number
  codigo: string
  modalidade_grupo: 'infantil' | 'fund1' | 'fund2' | 'eja' | 'integral' | null
  /** Grupos comerciais cobertos por este pedido; null = legado. */
  grupos_produto: GrupoProduto[] | null
  avulso: boolean
  registrado_por: string | null
  criado_em: string
  status_validacao?: StatusValidacaoPedido
  validado_por?: string | null
  validado_em?: string | null
  valor_planejado?: number | null
  valor_previsto?: number | null
  fornecedor?: { nome: string }
  registrado?: { nome: string }
}

export interface CompraItem {
  id: string
  compra_id: string
  alimento_id: string
  quantidade: number
  quantidade_pnae: number | null
  quantidade_alocada: number
  valor_unitario: number
  justificativa: string | null
  lote: string | null
  validade: string | null
  alimento?: { nome: string; categoria?: string; produto_id?: string | null }
}

export interface EntradaEstoque {
  id: string
  data: string
  escola_id: string
  alimento_id: string
  quantidade: number
  observacoes: string | null
  entrega_id: string | null
  registrado_por: string
  criado_em: string
}

export interface AjusteEstoque {
  id: string
  escola_id: string
  alimento_id: string
  /** Data em que o ajuste foi registrado */
  data: string
  /** Mês de referência do estoque (YYYY-MM-01) */
  mes_referencia: string
  quantidade: number
  motivo: string
  registrado_por: string | null
  criado_em: string
}

export interface CalendarioDia {
  id: string
  data: string
  tipo: TipoDia
  trimestre: number | null
  semana_cardapio: number | null
}

export interface CalendarioExcecao {
  id: string
  data: string
  modalidade: ModalidadeEnsino
  motivo: string | null
}

export interface Configuracoes {
  id: number
  municipio: string | null
  estado: string | null
  secretaria: string | null
  nutricionista_responsavel: string | null
  ano_letivo: number | null
  fiscal_contrato: string | null
  fornecedor_atual: string | null
  cnpj_fornecedor: string | null
}

export interface LogAuditoria {
  id: number
  usuario_id: string | null
  acao: string
  tabela: string
  registro_id: string | null
  dados_anteriores: Record<string, unknown> | null
  dados_novos: Record<string, unknown> | null
  criado_em: string
}

export interface SaldoContrato {
  id: string
  alimento: string
  grupo: string
  unidade: string
  quantidade_contratada: number
  quantidade_pedida: number
  valor_unitario: number
  valor_total: number
  quantidade_entregue: number
  saldo_quantidade: number
  saldo_valor: number
  pct_executado: number
  status: StatusContrato
}

export interface ConsumoPrevisto {
  data: string
  escola_id: string
  escola: string
  rota_id: string | null
  alimento_id: string
  alimento: string
  grupo: string
  unidade: string
  modalidade: ModalidadeEnsino
  quantidade: number
}

export interface NecessidadePeriodo {
  rota_id: string | null
  rota: string | null
  escola_id: string
  escola: string
  alimento_id: string
  alimento: string
  grupo: string
  unidade: string
  quantidade: number
  valor_unitario: number
  valor_total: number
}

export interface EstoqueSaldo {
  escola_id: string
  escola: string
  rota_id: string | null
  rota: string | null
  alimento_id: string
  alimento: string
  grupo: string
  unidade: string
  total_entradas: number
  consumo_previsto: number
  total_ajustes: number
  saldo: number
  primeira_entrada: string | null
}

export const GRUPOS: { value: GrupoProduto; label: string }[] = [
  { value: 'secos', label: 'Gêneros Secos' },
  { value: 'hortifruti', label: 'Hortifruti' },
  { value: 'proteinas', label: 'Proteínas' },
  { value: 'ovos', label: 'Ovos' },
  { value: 'polpas', label: 'Polpas' },
  { value: 'paes', label: 'Pães' },
]

export const NIVEIS_R065: { key: NivelEnsinoR065; label: string }[] = [
  { key: 'infantil', label: 'Infantil' },
  { key: 'fund_menor', label: 'Fundamental Menor' },
  { key: 'fund_maior', label: 'Fundamental Maior' },
  { key: 'eja', label: 'EJA' },
]

export const TURNOS_R065 = [
  { key: 'm', label: 'M' },
  { key: 't', label: 'T' },
  { key: 'n', label: 'N' },
  { key: 'i', label: 'I' },
] as const

export const MODALIDADES: { value: ModalidadeEnsino; label: string }[] = [
  { value: 'creche', label: 'Creche' },
  { value: 'pre', label: 'Pré' },
  { value: 'fund1', label: 'Fund. I' },
  { value: 'fund2', label: 'Fund. II' },
  { value: 'medio', label: 'Médio' },
  { value: 'eja', label: 'EJA' },
  { value: 'integral', label: 'Integral' },
]

export const REFEICOES = [
  { value: 'lanche_manha', label: 'Lanche manhã' },
  { value: 'almoco', label: 'Almoço' },
  { value: 'lanche_tarde', label: 'Lanche tarde' },
  { value: 'jantar', label: 'Jantar' },
] as const

export const DIAS_SEMANA = [
  { value: 1, label: 'Seg' },
  { value: 2, label: 'Ter' },
  { value: 3, label: 'Qua' },
  { value: 4, label: 'Qui' },
  { value: 5, label: 'Sex' },
] as const

export const PERFIL_LABELS: Record<PerfilUsuario, string> = {
  admin: 'Administrador',
  nutricionista: 'Nutricionista SEMED',
  logistica: 'Logística',
  fiscal: 'Nutricionista ISEN',
  responsavel_escola: 'Responsável da escola',
}

export const STATUS_VALIDACAO_LABELS: Record<StatusValidacaoEntrega, string> = {
  pendente_fornecedor: 'Aguardando logística',
  pendente_escola: 'Aguardando escola',
  pendente_nutricionista: 'Aguardando nutricionista',
  concluida: 'Concluída',
}
